import HsaFsaHero from "@/views/hsa-fsa/sections/HsaFsaHero";
import HsaFsaPayments from "@/views/hsa-fsa/sections/HsaFsaPayments";
import HsaFsaDates from "@/views/hsa-fsa/sections/HsaFsaDates";
import HsaFsaCta from "@/views/hsa-fsa/sections/HsaFsaCta";
import HsaFsaFaqs from "@/views/hsa-fsa/sections/HsaFsaFaqs";
import HsaFsaSteps from "@/views/hsa-fsa/sections/HsaFsaSteps";

/* `position` is the section_viewed index; keep it in page order. */
const HsaFsaView = () => (
  <>
    <HsaFsaHero position={0} />
    <HsaFsaPayments position={1} />
    <HsaFsaSteps position={2} />
    <HsaFsaDates position={3} />
    <HsaFsaCta position={4} />
    <HsaFsaFaqs position={5} />
  </>
);

export default HsaFsaView;
